import { render, staticRenderFns } from "./AuthorAvatarEditBtn.vue?vue&type=template&id=6e7bb33a&scoped=true&"
import script from "./AuthorAvatarEditBtn.vue?vue&type=script&lang=js&"
export * from "./AuthorAvatarEditBtn.vue?vue&type=script&lang=js&"
import style0 from "./AuthorAvatarEditBtn.vue?vue&type=style&index=0&id=6e7bb33a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7bb33a",
  null
  
)

export default component.exports